/* Eloura Custom JS: CTA-Label, variantenbewusste Sticky-Bar, Abschluss-CTA */
(function(){
  var LABEL='Ripple in den Warenkorb';
  function apply(){
    try{ if(window.variantStrings){ window.variantStrings.addToCart=LABEL; } }catch(e){}
    document.querySelectorAll('.product-form__submit').forEach(function(btn){
      if(btn.hasAttribute('disabled')) return; // nicht bei ausverkauft
      var span=btn.querySelector('span');
      if(span){ if(span.textContent.trim()!==LABEL){ span.textContent=LABEL; } }
      else if(btn.textContent.trim()!==LABEL){ btn.textContent=LABEL; }
    });
  }
  function selectedColor(){
    var i=document.querySelector('variant-selects input[type="radio"]:checked, variant-radios input[type="radio"]:checked');
    return i ? i.value : '';
  }
  function priceText(){
    var el=document.querySelector('.price__regular .price-item--regular');
    return el ? el.textContent.trim().replace(/\s+/g,' ') : '€59,90 EUR';
  }
  function updateBars(){
    var c=selectedColor(), p=priceText();
    var label='Ripple'+(c?' · '+c:'')+' · '+p;
    var st=document.querySelector('#eloura-sticky .et');
    if(st){ st.textContent=label; }
    document.querySelectorAll('[data-eloura-summary]').forEach(function(el){ el.textContent=label; });
  }
  function bindFinal(){
    var b=document.getElementById('eloura-final-btn');
    if(!b||b.dataset.bound) return;
    b.dataset.bound='1';
    b.addEventListener('click',function(){
      var addBtn=document.querySelector('product-form form [name="add"], form[action*="/cart/add"] [name="add"]');
      if(addBtn){ addBtn.click(); }
    });
  }
  function init(){ apply(); updateBars(); bindFinal(); }
  if(document.readyState!=='loading'){ init(); } else { document.addEventListener('DOMContentLoaded',init); }
  document.addEventListener('change',function(e){ if(e.target.closest && e.target.closest('variant-radios,variant-selects,.product-form__input')){ setTimeout(function(){ apply(); updateBars(); },120);} });
  setTimeout(init,600);
})();
/* Eloura Tracking: Meta-Pixel-Events (feuern nur, wenn fbq geladen ist) */
(function(){
  function fb(ev,params){ try{ if(window.fbq){ fbq('track', ev, params||{}); } }catch(e){} }
  var PROD={content_name:'Ripple', content_ids:['15007306187101'], content_type:'product', value:59.90, currency:'EUR'};
  function init(){
    if(document.querySelector('product-form')){ fb('ViewContent', PROD); }
    document.addEventListener('click',function(e){
      if(!e.target.closest) return;
      var t=e.target.closest('.product-form__submit, #eloura-sticky-btn, #eloura-final-btn');
      if(t){ fb('AddToCart', PROD); }
    },true);
  }
  if(document.readyState!=='loading'){ init(); } else { document.addEventListener('DOMContentLoaded',init); }
})();
